import { mapState } from 'vuex';

const isProduction = process.env.VUE_APP_ENV === 'production';
const isPrerender = process.env.VUE_APP_PRERENDER === 'true';

export default {
    computed: {
        ...mapState({
            $_isInternal: state => state.user.isInternal,
        }),
    },
    methods: {
        isFeatureEnabled(feature) {
            switch (feature) {
                case 'personalized_navbar':
                case 'referral_report':
                case 'search_similar_face':
                case 'library_download':
                case 'elastic_search_2020_01':
                case 'disable_paypal_for_twd':
                case 'contributor_new_media_types':
                case 'monthly_subscription':
                case 'midjourney_prompt':
                case 'buyer_new_media_types':
                case 'buyer_midjourney_prompt':
                case 'streaming-ai':
                    return true;
                // case 'artist_element_counts': // MP-2095
                case 'send_for_review':
                // case 'monthly_subscription':
                // case 'gcp_promo_new_ui':
                // case 'deprecate_collections':
                    return !isProduction || this.$_isInternal;
                case 'change_license':
                case 'filter_collection':
                case 'media_player':
                case 'music_new_categories':
                case 'regenerate_previews':
                case 'sort_popular_local':
                case 'new_paypal':
                case 'search_result_scores':
                // case 'streaming-ai':
                    return !isProduction;
                // case 'unlimited_subscription_header':
                case 'audio_stems':
                case 'artist_profile_picture_edit':
                case 'settings_tab_for_contributor':
                case 'artist_element_counts': // MP-2095
                case 'gcp_promo_new_ui':
                case 'deprecate_collections':
                case 'contributor_report_views':
                case 'contributor_report_favorites':
                case 'unlimited_subscription_header':
                case 'contributor_redesign_2023':
                case 'contributor-sidebar-no-products':
                    return true;
                case 'tw_vat_invoice':
                case 'hero_program':
                case 'upload_vector_preview':
                case 'auth-modals':
                    return false;
                case 'recaptcha':
                    return !isPrerender && (isProduction || ['staging'].includes(process.env.VUE_APP_ENV));
                // case 'contributor_report_views':
                // case 'contributor_report_favorites':
                //     return !isProduction || this.$_isInternal; // es issue 2022-08-12
                    // return !isProduction || this.$i18n.locale === 'zh-hant' || this.$_isInternal;
                case 'quote':
                case 'credits_purchase':
                default:
                    return false;
            }
        },
    },
};
